import React, { FC } from 'react';
import { Theme, Box, Typography, makeStyles, Container } from '@material-ui/core';

interface OurPartnersSectionProps {
  title: string;
  text: string;
  secondText: string;
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    marginBottom: theme.spacing(26),
  },
  title: {
    fontWeight: 500,
    color: theme.palette.primary.dark,
    paddingLeft: theme.spacing(2),
    borderLeft: '5px solid #E0621E',
    marginBottom: theme.spacing(5),
  },
  text: {
    marginBottom: theme.spacing(3),
  },
  fullDivider: {
    width: '100%',
    height: 1,
    backgroundColor: theme.palette.secondary.light,
    margin: theme.spacing(15, 0),
    [theme.breakpoints.up('md')]: {
      margin: theme.spacing(26, 0),
    },
  },
}));

const OurPartnersSection: FC<OurPartnersSectionProps> = ({ title, text, secondText }) => {
  const classes = useStyles();
  return (
    <Container fixed className={classes.root} id={'our-partners'}>
      <Box className={classes.fullDivider} />
      <Typography variant="h2" className={classes.title} data-aos="fade-up">
        {title}
      </Typography>
      <Typography variant="body1" className={classes.text} data-aos="fade-up" data-aos-delay="300">
        {text}
      </Typography>
      <Typography variant="body1" data-aos="fade-up" data-aos-delay="400">
        {secondText}
      </Typography>
    </Container>
  );
};

export default OurPartnersSection;
